import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../assets/images/home_logo.png';
import toggleImageDot from '../../../../assets/images/toggle_image.png';
import toggleImageWithoutDot from '../../../../assets/images/toggle_imagee.png';
import { useSelector, useDispatch } from 'react-redux';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import kudzuPlusLogo from '../../../../assets/images/kudzuPluseLocgo.png'
import { appTheme, showKudzuPlusPrompt } from '../../../../helpers/utils/Utils';
import { PAID_PROMO_KEY, TRAIL_PROMO_KEY } from '../../../../network/URLConstants';
import Cookies from 'js-cookie';
import { addLineBreaks } from '../../../../utils';
import kudzuSmioneLogo from '../../../../assets/images/kudzu_smione_logo.png';
import SmiLogo from '../../../../assets/smi-kudzu-images/Smi_Logo.png'


const NavBar = ({ isSidebarOpen, handleSidebarToggle, unreadCount, savingEnrollClicked, ReferralLogoUri, SidebarOpen }) => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isReferralLogoUri, setIsReferralLogoUri] = useState(ReferralLogoUri);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentpath = useLocation()

  const isAcceptAgreement = useSelector(state => state.isAcceptAgreement)
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  // const savingsNewClicked = useSelector(state => state.savingsNewClicked);
 
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse)
  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const [toolTipShown, setTooltipShown] = useState(false)
  // const promoKey = useSelector(state => JSON.parse(state.loggedInResponse?.Promos?.[0]?.PromoKey));
  const newbadgeCheck = cards && cards.length > 0   ? `newbadge${cards[0].CardKey}`  : null;
  const savingsNewClicked = Cookies.get(newbadgeCheck) ? true : false;
  const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);
  const appThemedata = appTheme(kudzuPlusTrue)
  const [isKudzuBannerActive, setIsKudzuBannerActive] = useState(false);
  const smiOneTrue = useSelector((state) => state.smiOneAccountTrue);

  

const handleClick = (page) => {
    const updatedIsSidebarOpen = true;
    handleSidebarToggle(updatedIsSidebarOpen);
    navigate(page);
  };

const doessmiONECardAllowSavings = () => {
    const smiONECard = cards?.find(
      (item) =>
        item.ProgramKey !== 200 &&
        item.AccountTypeBit63 === 1
    );
   
    if(smiONECard != null && smiONECard != undefined)
      return smiONECard.AllowSavings;
 
    return false;
  }

  const handletoolTipClick = () => {
    const tooltipCookieNameForSaving = `tooltipfor_kudzu_badge-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
    setTooltipShown(false)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const kadzuBanner = `banner_for_kudzu-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards[0].CardKey}`;
      const tooltipForBadge = `tooltipfor_kudzu_badge-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards[0].CardKey}`;
  
      const banner = Cookies.get(kadzuBanner);
      const tooltipState = Cookies.get(tooltipForBadge);
  
      setIsKudzuBannerActive(banner === 'true');
  
      if ((tooltipState === 'false' || tooltipState === undefined) && banner === 'true') {
        setTooltipShown(true);
      } else {
        setTooltipShown(false);
      }
    }, 500);
  
    return () => clearInterval(interval);
  }, [promoKey, cards]);
  
  
  




  const ListItemstyles = "font-[700] block py-2  md:pl-3 md:pr-4 text-white text-[14px]  sm:text-[12px] text-sm md:text-[18px] leading-[18px] font-hanken-grotesk cursor-pointer"
  return (
    <>
      <nav className="bg-[#262B3A]">
        <div className={`max-w-full flex flex-wrap items-center justify-between 
        sm:px-[6%] md:px-[6%] px-10 py-6  ${SidebarOpen ? 'sm:mr-[50px]' : ""}`}>
          <div className={`flex flex-row items-center transition-all duration-1000 gap-4 ${SidebarOpen ? 'sm:ml-[-195px] md:ml-[-195px]' : ''}`}>
            <Link to="/home">
              <img
                src={isSmiOneIsTrue ?  SmiLogo :  appThemedata.kudzuLogo}
                onClick={() => {
                  dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('ActivityTab') } })
                  dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: '' } });
                }}
                className={`${kudzuPlusTrue ? 'md:h-[25px] w-full h-[18px] ' : isSmiOneIsTrue ? "md:h-[39px] w-[97px] h-[29px] md:w-[130px]" : 'md:h-[39px] w-[97px] h-[29px] md:w-[130px]'}  cursor-pointer`}
                alt="Logo"
              />
            </Link>
            {kudzuPlusTrue && (
              <div className="relative">
                {isKudzuBannerActive && (
                <div
                  style={{ background: "linear-gradient(to right, #2965FB, #4B70B9, #30BC89)" }}
                  onClick={() => {
                    handletoolTipClick();
                    navigate('/Settings/manageMembershipKudzuplus');
                  }}
                  className={`text-white justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] 
                    rounded-[89px] flex items-center font-semibold lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px]  font-hanken-grotesk cursor-pointer`}
                >
                  {promoKey == PAID_PROMO_KEY ? "Trial" : "Plus"}
                </div>)}

                {toolTipShown &&
       
            <div className={` font-hanken-grotesk leading-4
              font-bold absolute top-[190%] -left-4 
             p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl w-[167px]
               shadow-lg  z-10 cursor-pointer transition-all duration-1000`}
                    onClick={() => { handletoolTipClick();
                      navigate('/Settings/manageMembershipKudzuplus');
                     }}>
                    <div className="tooltip-arrow"></div>
                    {promoKey == PAID_PROMO_KEY ? addLineBreaks(t('Tap_here_to_track_your_Kudzu+_progress')) : addLineBreaks(t('Explore_Kudzu+_features_in_more_detail'))}
                  </div>}
              </div>
            )}

            {
              isReferralLogoUri &&
              <img
                src={isReferralLogoUri}
                className="h-[29px] md:h-[39px] cursor-pointer ml-2"
                alt="Referral Logo"
                onError={event => {
                  setIsReferralLogoUri(null)

                }}
              />

            }

          </div>

          <div className={`${SidebarOpen ? 'sm:flex-2' : 'sm:hidden'}`}>
            </div>

          {!isAcceptAgreement &&
            <div className="flex">
              <div
                className={`hidden ml-auto w-full sm:block sm:w-auto transition-all duration-1000 
                ${isSidebarOpen ? 'md:mr-[0rem] sm:mr-[0rem]' : 'mr-[0rem]'}`}
                id="navbar-default"
              >
                <ul
                  className="font-medium flex flex-col p-4 sm:p-0 mt-4
                             border border-gray-100 rounded-lg sm:flex-row sm:space-x-8 
                             sm:mt-0 sm:border-0 dark:bg-gray-800 
                             sm:dark:bg-gray-900 dark:border-gray-700 mr-8"
                > 
                  {isSmiOneIsTrue &&    
                   <li>
                    <Link
                      to={"/SmioneCard"}
                      className={ListItemstyles}
                      onClick={() => {
                        dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: '' } });
                        logFirebaseEvents("Home", "smiONE_Clicked", "smiONE_Clicked", "", "")
                      }}
                    >
                      smiONE
                    </Link>
                  </li>}
               
                  <li>
                    <Link
                      to={isSmiOneIsTrue ? "/Spending" : "/Spending"}
                      className={ListItemstyles}
                      onClick={() => {
                        dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: '' } });
                        logFirebaseEvents("Home", "Spending_Clicked", "Spending_Clicked", "", "")
                      }}
                    >
                      {t('NavbarChecking')}
                    </Link>
                  </li>
                 {cards !== null && (smiOneTrue ? doessmiONECardAllowSavings() : cards[0]?.AllowSavings) && <li>
                    <div
                      //to="/Savings"

                      className={ListItemstyles}
                    >
                      <div className='flex items-center justify-between'
                        tabIndex={'0'}
                        onClick={() => {
                          debugger;
                          dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: '' } });
                          if (savingsCardAvailable == false && savingsNewClicked == false) {
                            const savingsNewPayload = { savingsNewClicked: true };
                            dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
                            savingEnrollClicked();
                          } else if (savingsCardAvailable == false && savingsNewClicked == true) {
                            savingEnrollClicked();
                          } else {
                            navigate('/Savings');
                          }
                          logFirebaseEvents("Home", "Savings_Clicked", "Savings_Clicked", "", "")

                        }}>
                        {/* {t('NavbarSavings')} */}
                        <span className='mr-4'>{t('NavbarSavings')}</span>
                        {(savingsCardAvailable == false && savingsNewClicked == false) && <div
                          className={`bg-[#2965FB] flex items-center text-white
                        justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                        lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                          onClick={() => {

                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                            }
                          }}
                          tabIndex={0} // Set tabIndex here for the button
                        >
                          New
                        </div>}
                        {(savingsCardAvailable == false && savingsNewClicked == true) && <div
                          className={`border-2
                          border-[var(--enroll-btnBorder)]  flex items-center text-[var(--enroll-btnColor)]
                        justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                        lg:text-[15px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                          onClick={() => {

                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                            }
                          }}
                          tabIndex={0} // Set tabIndex here for the button
                        >
                          Enroll
                        </div>}
                      </div>


                    </div>
                  </li>}
                  {cards !== null && cards[0]?.AllowPayPerks && <li>
                    <Link
                      to="/PayPerks"
                      className={ListItemstyles}
                      onClick={() => logFirebaseEvents("Home", "PayPerks_Clicked", "PayPerks_Clicked", "", "")}
                    >
                      {t('NavbarPerks')}
                    </Link>
                  </li>}
                  {cards !== null && cards?.find(card => card.AccountTypeBit63 === 64)?.IsClimbAllowed &&  <li>
                    <Link
                      to={isShowKudzuPlusPrompt ? "/Climb/ClimbMenu" : "/Climb/ClimbMenu"}
                      state={{ isClimbShowPopups: true }}
                      className={`${ListItemstyles}`}
                      onClick={() => {
                        logFirebaseEvents("Home", "Climb_Clicked", "Climb_Clicked", "", "");
                        const currentPath = { currentPathFromStore: currentpath.pathname };
                        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                      }}
                    >
                      {t('Toolkit')}
                    </Link>
                  </li>}
                  <li>
                    <Link
                      to={isSmiOneIsTrue ? '/Help' : '/Help/FAQ'}
                      className={`${ListItemstyles}`}
                      onClick={() => logFirebaseEvents("Home", "Help_Clicked", "Help_Clicked", "", "")}
                    >
                      {t('helpText')}
                    </Link>
                  </li>

                </ul>
              </div>
              <div
                className={`transition-all duration-1000 
                   ${isSidebarOpen ? 'mr-[13rem]' : 'mr-0'}`}
              >
                <button onClick={() => handleClick('')} className="text-white">
                  <img
                    src={(unreadCount || (!savingsCardAvailable && savingsNewClicked == false)) ? `${toggleImageDot}` : `${appThemedata.toggleImageWithoutDot}`}
                    className="lg:w-[19px] lg:h-[19px] md:h-[17px] md:w-[17px] sm:h-[16px] sm:w-[16px] w-[17px] h-[17px] sm:mt-2"
                    alt="toggleImage"
                  />
                </button>
              </div>
            </div>}
        </div>
      </nav>
    </>
  );
};

export default NavBar;
